import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [];

const AsignadasPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Asignadas</PageTitle>
      <View />
    </>
  );
};

export { AsignadasPage };
